
import loaderIcon from "../img/loader.png";

export function Loader(){
    return <img className="animate-spin w-6 mx-auto" src={loaderIcon} alt="loading icon" />
}